var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "go-list-item",
      class: { noEvent: _vm.isWaitingResponse || _vm.isNotActive },
      on: {
        mouseover: function ($event) {
          _vm.isHovered = true
        },
        mouseleave: function ($event) {
          _vm.isHovered = false
        },
      },
    },
    [
      _c("div", { staticClass: "go-card-header" }, [
        _c("div", { staticClass: "go-card-info" }, [
          _vm.styleFor !== undefined &&
          _vm.styleFor ===
            _vm.REFERENCE_STYLE_FOR.BRIEFING_REFERENCE.toString() &&
          (_vm.isHovered ||
            (_vm.checkedReferenceIds !== undefined &&
              _vm.checkedReferenceIds.includes(_vm.dataModelForView.id)))
            ? _c(
                "button",
                {
                  staticClass: "btn go-btn-check",
                  class: {
                    active:
                      _vm.checkedReferenceIds !== undefined &&
                      _vm.checkedReferenceIds.includes(_vm.dataModelForView.id),
                  },
                  attrs: {
                    type: "button",
                    "data-toggle": "button",
                    "aria-pressed": "false",
                    disabled: _vm.isWaitingResponse,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleClickCheckedReference(_vm.formModel)
                    },
                  },
                },
                [_c("i", { staticClass: "go-icon-18 go-icon-check" })]
              )
            : _vm.dataModelForView.isNew !== undefined &&
              _vm.dataModelForView.isNew === true
            ? _c(
                "div",
                { staticClass: "go-info-item go-num-doc custom-new-info" },
                [_vm._v("\n        N\n      ")]
              )
            : _c(
                "div",
                {
                  staticClass: "go-info-item go-num-doc",
                  staticStyle: {
                    width: "auto",
                    display: "flex",
                    "white-space": "nowrap",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.dataModelForView.indexNumber) +
                      "\n      "
                  ),
                ]
              ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "go-card-sub",
          class: {
            "selectedItem active":
              _vm.styleFor !== undefined &&
              _vm.styleFor ===
                _vm.REFERENCE_STYLE_FOR.BRIEFING_REFERENCE.toString() &&
              _vm.checkedReferenceIds !== undefined &&
              _vm.checkedReferenceIds.includes(_vm.dataModelForView.id),
          },
        },
        [
          _c("div", { staticClass: "go-card-body" }, [
            _c("div", { staticClass: "go-block-body" }, [
              _c(
                "a",
                {
                  staticClass: "go-card-title",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.handleClickToTitle(_vm.formModel)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.dataModelForView.title ||
                          _vm.dataModelForView.description
                      ) +
                      "\n        "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "go-block-footer" }, [
              _c("div", { staticClass: "go-card-info" }, [
                _vm.dataModelForView.type === _vm.REFERENCE_TYPE.NOTE.toString()
                  ? _c("div", { staticClass: "go-info-item" }, [
                      _c("span", { staticClass: "go-label" }, [
                        _vm._v(_vm._s(_vm.$t("briefing.view-card.label.note"))),
                      ]),
                    ])
                  : _vm.dataModelForView.type ===
                    _vm.REFERENCE_TYPE.FILE.toString()
                  ? _c("div", { staticClass: "go-info-item" }, [
                      _c("span", { staticClass: "go-label" }, [
                        _vm._v(_vm._s(_vm.$t("briefing.view-card.label.file"))),
                      ]),
                    ])
                  : _c("div", { staticClass: "go-info-item go-channel" }, [
                      _vm.dataModelForView.faviconImage !== undefined &&
                      _vm.dataModelForView.faviconImage.trim().length > 0 &&
                      !_vm.getErrorElementId.includes(
                        "favicon_" +
                          _vm.styleFor +
                          "_" +
                          _vm.dataModelForView.id
                      )
                        ? _c(
                            "span",
                            {
                              staticClass: "go-channel-thumb",
                              attrs: {
                                id:
                                  "favicon_" +
                                  _vm.styleFor +
                                  "_" +
                                  _vm.dataModelForView.id,
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: _vm.dataModelForView.faviconImage,
                                  alt: "",
                                },
                                on: {
                                  error: function ($event) {
                                    return _vm.hideElementByIdLocalComponent(
                                      "favicon_" +
                                        _vm.styleFor +
                                        "_" +
                                        _vm.dataModelForView.id
                                    )
                                  },
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "go-channel-name" }, [
                        _vm._v(_vm._s(_vm.dataModelForView.channel)),
                      ]),
                    ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.styleFor !== undefined &&
          _vm.styleFor ===
            _vm.REFERENCE_STYLE_FOR.BRIEFING_REFERENCE.toString() &&
          _vm.dataModelForView.type !== _vm.REFERENCE_TYPE.NOTE.toString() &&
          _vm.dataModelForView.imageUriThumbnail !== undefined &&
          _vm.dataModelForView.imageUriThumbnail.trim().length > 0 &&
          !_vm.getErrorElementId.includes(
            "imageReferenceThumbnail_" +
              _vm.styleFor +
              "_" +
              _vm.dataModelForView.id
          )
            ? _c(
                "div",
                {
                  staticClass: "image-view-element",
                  class: {
                    "go-card-img":
                      _vm.dataModelForView.type !==
                        _vm.REFERENCE_TYPE.NOTE.toString() &&
                      _vm.dataModelForView.type !==
                        _vm.REFERENCE_TYPE.FILE.toString(),
                    "go-card-icon":
                      _vm.dataModelForView.type ===
                      _vm.REFERENCE_TYPE.FILE.toString(),
                  },
                  attrs: {
                    id:
                      "imageReferenceThumbnail_" +
                      _vm.styleFor +
                      "_" +
                      _vm.dataModelForView.id,
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: _vm.dataModelForView.imageUriThumbnail,
                      alt: "",
                    },
                    on: {
                      error: function ($event) {
                        return _vm.hideElementByIdLocalComponent(
                          "imageReferenceThumbnail_" +
                            _vm.styleFor +
                            "_" +
                            _vm.dataModelForView.id
                        )
                      },
                    },
                  }),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }